import {lazy} from '@aboutyou/lazy-imports';

export const SportswearPage = lazy(
  () =>
    import('./SportswearPage.eager').then(mod => ({
      default: mod.SportswearPage,
    })),
  {aboveTheFold: true, isSsrAndNeedsHydration: true},
);
